type Params = {
  mediaFilters:
    | {
        id?: number;
        name: string;
        url: string;
      }[]
    | null;
  filterName: string;
};

export default function getMediaFilterUrl({
  mediaFilters,
  filterName,
}: Params) {
  if (mediaFilters) {
    const filter = mediaFilters?.find(({ name }) => name === filterName);
    return filter?.url;
  }
}
